:host {
  display: block;
  max-width: 100%;
  --separator-display: flex;
  --border-color: var(--chart-100-pressed);
}

gz-single-select {
  margin-right: -1px;
  --delete-button-visiblity: none;

  &:hover,
  &:active,
  &:focus-within,
  &:focus-visible,
  &:focus {
    z-index: 3;
  }

  &:not(:hover, :focus, :focus-within, :active) {
    --dropdown-border-top: 1px solid var(--border-color);
    --dropdown-border-bottom: 1px solid var(--border-color);
    --dropdown-border-right: 1px solid transparent;
    --dropdown-border-left: 1px solid var(--border-color);
    --input-border-radius: 4px 0 0 4px;
    --dropdown-border-radius: 4px;
    --dropdown-active-border-radius: 4px;
    z-index: 2;
  }
}

gz-custom-input-search {
  &:hover,
  &:active,
  &:focus-within,
  &:focus-visible,
  &:focus {
    z-index: 3;
  }

  &:not(:hover, :focus, :focus-within, :active) {
    --custom-input-border-top: 1px solid var(--border-color);
    --custom-input-border-bottom: 1px solid var(--border-color);
    --custom-input-border-right: 1px solid var(--border-color);
    --custom-input-border-left: 1px solid transparent;
    --border-radius: 0 4px 4px 0;
  }
}

.separator {
  border-top: 1px solid var(--border-color);
  border-bottom: 1px solid var(--border-color);
  background: transparent;
  display: var(--separator-display, flex);
  align-items: center;

  &:before {
    content: '';
    min-width: 1px;
    width: 1px;
    display: block;
    height: 15px;
    background-color: var(--border-color);
    z-index: 2;
    position: absolute;
  }
}
